module.exports = "img/flags/SZ.a3a45f3.png";